<template>
  <div v-click-outside="hide" class="bottom-block">
    <div  v-if="condition.isShow" style="position: relative">
      <div class="chat-block">
        <quotation-chat ref="quotationChat" :quotation-id="quotationRequestId"></quotation-chat>
      </div>
    </div>
    <a @click="handle()" href="javascript:void(0);" class="option image">
      <ChatIcon />
    </a>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import QuotationChat from "@/components/app/quotation/QuotationChat.vue";
import { ChatIcon } from '@/shared/ui/icons';

export default {
  name: 'ChatBtn',
  props: ['quotationRequestId'],
  components:  { QuotationChat, ChatIcon },
  directives: {ClickOutside},
  data: function () {
    return {
      condition: {
        isShow: false,
      },
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    hide: function () {
      return this.condition.isShow = false;
    },
    handle: function () {
      return this.condition.isShow = ! this.condition.isShow
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-block {
  top: 20px;
  z-index: 3000;
  right: -13px;
  width: 300px;
  position: absolute;
  background: #FFFFFF;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;

  .chat-wrap{
    border-radius: 8px;
  }
}
</style>
